// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"0c373c1e","556":"9794fd92","901":"f12dd7ff","939":"bb8493e5"}[chunkId] + ".chunk.css";
};